import { tss } from 'tss-react/mui';

const useStyles = tss
  .withParams<{
    isLayoutMobile: boolean;
  }>()
  .create(({ isLayoutMobile, theme }) => {
    return {
      assetDetailsSubTopbar: {
        backgroundColor: theme.vars.palette.background.elevation1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        zIndex: 2
      },
      topContent: {
        boxShadow: isLayoutMobile ? theme.shadows[2] : 'none',
        display: 'flex',
        flexDirection: isLayoutMobile ? 'column' : 'row',
        gap: theme.spacing(2),
        justifyContent: 'space-between',
        padding: theme.spacing(3),
        width: '100%'
      },
      topContentOrganizationName: {
        display: 'inline',
        fontSize: '1rem',
        fontWeight: 'normal'
      }
    };
  });

export default useStyles;
